export default "__VITE_ASSET__b995ee3a__"